import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import changePass from "./profile/settings/changePass/slice";
import rent from "./rent/slice";
import cart from "./cart/slice";
import authAndReg from "./profile/authAndReg/slice";
import getToken from "./profile/paytoken//slice";
import getGrunt from "./profile/grunt/slice";
import getCards from "./profile/cards/slice";
import getHistory from "./profile/history/slice";
import getProfile from "./profile/settings/getProfileInfo/slice";
import changeName from "./profile/settings/changeDataProfile/slice";
import addCard from "./profile/cards//slice";
import rerender from "./rerender/slice";
import feedback from "./feedback/slice";
import training from "./training/slice";
import news from "./News/slice";
import appInfo from "./app/slice";
import contacts from "./contacts/slice";
import scheme from "./scheme/slice";
import products from "./products/slice";
import games from "./games/slice";
import tournaments from "./tournaments/slice";
import gallery from "./gallery/slice";

const store = configureStore({
  reducer: {
    appInfo,
    contacts,
    scheme,
    training,
    news,
    products,

    authAndReg,
    changePass,

    rerender,
    rent,
    cart,
    getCards,
    getGrunt,
    getHistory,
    getProfile,
    changeName,
    addCard,
    getToken,
    feedback,
    games,
    tournaments,
    gallery,
  },
  devTools: process.env.NODE_ENV !== "production",
});

type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export type RootState = ReturnType<typeof store.getState>;

export default store;
